import { Backend } from './backend';
import { checkFilters } from './utils';

class CorpAccountsApi {
    constructor() {
        this.path = '/retailers/accounts';
    }

    async getCorpAccountById(id) {
        try {
            return await Backend.send({
                method: 'get',
                url: `${this.path}/${id}`,
            });
        } catch (e) {
            throw e;
        }
    }

    async searchCorpAccounts({
        page,
        size,
        sortOrder,
        sortColumn,
        filters,
        query,
    }) {
        try {
            return await Backend.send({
                method: 'post',
                url: `${this.path}/search`,
                body: {
                    page,
                    size,
                    sortColumn: sortColumn || 'name',
                    sortOrder: sortOrder ? sortOrder.toUpperCase() : 'ASC',
                    filters: checkFilters(filters),
                    query,
                },
            });
        } catch (e) {
            throw e;
        }
    }

    async saveAccountContacts(id, accountContactObject) {
        try {
            return await Backend.send({
                method: 'put',
                url: `${this.path}/account-contacts-by-id/${id}`,
                body: accountContactObject,
            });
        } catch (e) {
            throw e;
        }
    }
}

export { CorpAccountsApi };
